export default {
  sendmail_loading: false,
  subscribe_mail_loading: false,
  get_started_loading: false,
};
